import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { FormControl } from '@mui/material';
import Select from '@mui/material/Select';
import { useInputStore } from 'Store';


const dropDownOptions = [
    { value: 'farmer', label: 'Farmer' },
    { value: 'agronomist', label: 'Agronomist' },
    { value: 'researcher', label: 'Researcher' },
    { value: 'policyMaker', label: 'Policy Maker' },
    { value: 'other', label: 'Other' },
];

export const RoleDropDown = () => {
    const who = useInputStore(state => state.who_are_you);
    const setValue = useInputStore((state) => state.set_value);

    const handleChange = (event) => {
        setValue({ "who_are_you": event.target.value });
    };

    return (
        <FormControl fullWidth>
            <InputLabel id="role-dropdown">Select Role</InputLabel>
            <Select
                labelId="role-dropdown"
                label="Select Role"
                value={who}
                onChange={handleChange}
               
            >
                {dropDownOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
       </FormControl> 
    );
};